import { normalizeClassId } from './classIdentity.mjs';

/** Runtime-neutral 2024/SRD 5.2 class spellcasting authority. */
export const CLASS_CASTING_PROFILES = Object.freeze({
  bard: Object.freeze({ id: 'bard', casterProgression: 'full', spellcasting: Object.freeze({ ability: 'charisma', spellListId: 'bard' }) }),
  cleric: Object.freeze({ id: 'cleric', casterProgression: 'full', spellcasting: Object.freeze({ ability: 'wisdom', spellListId: 'cleric' }) }),
  druid: Object.freeze({ id: 'druid', casterProgression: 'full', spellcasting: Object.freeze({ ability: 'wisdom', spellListId: 'druid' }) }),
  paladin: Object.freeze({ id: 'paladin', casterProgression: 'half', spellcasting: Object.freeze({ ability: 'charisma', spellListId: 'paladin' }) }),
  ranger: Object.freeze({ id: 'ranger', casterProgression: 'half', spellcasting: Object.freeze({ ability: 'wisdom', spellListId: 'ranger' }) }),
  sorcerer: Object.freeze({ id: 'sorcerer', casterProgression: 'full', spellcasting: Object.freeze({ ability: 'charisma', spellListId: 'sorcerer' }) }),
  warlock: Object.freeze({ id: 'warlock', casterProgression: 'pact', spellcasting: Object.freeze({ ability: 'charisma', spellListId: 'warlock' }) }),
  wizard: Object.freeze({ id: 'wizard', casterProgression: 'full', spellcasting: Object.freeze({ ability: 'intelligence', spellListId: 'wizard' }) }),
});

export const getClassCastingProfile = (classId) =>
  CLASS_CASTING_PROFILES[normalizeClassId(classId)] || null;

const ABILITY_KEYS = Object.freeze({ strength: 'str', dexterity: 'dex', constitution: 'con', intelligence: 'int', wisdom: 'wis', charisma: 'cha' });

/** Short ability key ('wis', 'cha', ...) of the first spellcasting class with a level, or null. */
export const getPrimarySpellcastingAbilityKey = (occupation = []) => {
  const entry = (Array.isArray(occupation) ? occupation : []).find((cls) =>
    getClassCastingProfile(cls?.Name || cls?.Occupation || cls?.name || cls?.class) && (Number(cls?.Level ?? cls?.level) || 0) >= 1);
  const profile = entry && getClassCastingProfile(entry.Name || entry.Occupation || entry.name || entry.class);
  return profile ? ABILITY_KEYS[profile.spellcasting.ability] : null;
};

